module.exports = __webpack_public_path__ + "static/media/count-4.898b82e1.mp3";